import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseStep.module.scss';

interface Props {
  className?: string;
  allSteps: StepItems[];
  current: number;
}

const getCss = (current: number, index: number) => {
  const currentStyle = classNames(css.PurchaseStep__Item, css.isCurrent);
  const doneStyle = classNames(css.PurchaseStep__Item, css.isDone);
  const defaultStyle = classNames(css.PurchaseStep__Item);

  if (current === index) {
    return currentStyle;
  } else if (current > index) {
    return doneStyle;
  }
  return defaultStyle;
};

export enum StepItems {
  Customer = 'customer',
  Payment = 'payment',
  Confirmation = 'confirmation',
}

const PurchaseStep = ({
  className,
  intl,
  allSteps,
  current,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseStep, className);
  const steps = allSteps.map((step, i) => ({
    css: getCss(current, i + 1), // NOTE: step starts with 1, in ModelTypeCourse.tsx
    label: `purchases.purchaseStep.${step}`,
  }));

  return (
    <ul className={classes}>
      {steps.map((step, index) => (
        <li key={index} className={step.css}>
          <span className={css.PurchaseStep__StepNumber}>{index + 1}</span>
          <span className={css.PurchaseStep__StepLabel}>
            {intl.formatMessage({ id: step.label })}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default injectIntl(PurchaseStep);
